import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-alert",
  templateUrl: "./alert.component.html",
  styleUrls: ["./alert.component.scss"],
})
export class AlertComponent {
  @Input() type!: string;
  @Input() message!: string;
  @Output() closeAlert = new EventEmitter<void>();
  @Input() id: string | null | undefined;
  closed = true;
  constructor(private router: Router) {}

  onClose() {
    this.closeAlert.emit();
  }

  navigateToReport(id: string | null | undefined) {
    // console.log(id,"id");
    this.router.navigate(["report", id]);
  }
}
